
import React,{Fragment, useState} from 'react'
import Form from './components/Form';
import Message from './components/Message';
import Weather from './components/Weather';
import Spinner from './components/Spinner';
import Header from './components/Header';

function App() {
let component;
const[searchText,saveSearchText] = useState('');
const[spinnerSelect,saveSpinnerSelect] = useState('')
const[message, saveMessage]= useState('')
const [result, saveResult]=useState({})
const [loading, saveLoading] = useState(false)

component=<Header/>

if(message!==''){
 
  component=<Message
    message={message}
  />
}
if(loading){
  component=<Spinner/>

  //{
    setTimeout(() => {
      saveLoading(false)
    }, 2000);
  
     
    
 //}
}
if(!loading && Object.entries(result).length>0){
  component=<Weather
      result={result}
      saveLoading={saveLoading}
    />
}






  return (
    <div>
      <Fragment>
        {component}
        
        
        <Form
          searchText={searchText}
          saveSearchText={saveSearchText}
          spinnerSelect={spinnerSelect}
          saveSpinnerSelect={saveSpinnerSelect}
          saveMessage={saveMessage}
          saveResult={saveResult}
          saveLoading={saveLoading}
        />
     
      </Fragment>
      </div>
  
  );
}

export default App;
